import React from 'react';
import { Modal, Upload, Progress, Space, Button } from 'antd';
import { UploadOutlined } from '@ant-design/icons';

interface ImportOrdersModalProps {
  open: boolean;
  loading: boolean;
  progress: number;
  onClose: () => void;
  onImport: (file: File) => Promise<boolean | void> | boolean | void;
}

const ImportOrdersModal: React.FC<ImportOrdersModalProps> = ({
  open,
  loading,
  progress,
  onClose,
  onImport,
}) => {
  return (
    <Modal
      title="导入订单数据"
      open={open}
      onCancel={onClose}
      footer={null}
      width={500}
    >
      <div>
        <div style={{ marginBottom: 16 }}>
          <ul style={{ margin: 0, paddingLeft: '20px', color: '#666' }}>
            <li>支持 .xlsx、.xls、.csv 格式文件</li>
            <li>文件大小不能超过 10MB</li>
            <li>以「订单编号」为唯一性判断条件</li>
            <li>如果记录已存在，将会更新现有数据</li>
          </ul>
        </div>

        {progress > 0 && (
          <div style={{ marginBottom: 16 }}>
            <Progress percent={progress} status={loading ? 'active' : 'success'} size="small" />
          </div>
        )}

        <Upload.Dragger
          name="file"
          multiple={false}
          accept=".xlsx,.xls,.csv"
          beforeUpload={onImport as any}
          showUploadList={false}
          disabled={loading}
        >
          <p className="ant-upload-drag-icon">
            <UploadOutlined style={{ fontSize: '48px', color: loading ? '#ccc' : '#1890ff' }} />
          </p>
          <p className="ant-upload-text" style={{ color: loading ? '#ccc' : '#333' }}>
            {loading ? '正在导入中...' : '点击或拖拽文件到这里进行导入'}
          </p>
          <p className="ant-upload-hint" style={{ color: '#999' }}>
            支持 Excel (.xlsx, .xls) 和 CSV 格式文件
          </p>
        </Upload.Dragger>

        <div style={{ marginTop: 16, textAlign: 'right' }}>
          <Space>
            <Button onClick={onClose} disabled={loading}>
              取消
            </Button>
          </Space>
        </div>
      </div>
    </Modal>
  );
};

export default ImportOrdersModal;

